import { AnalyticsDispatcher } from '../../internal/AnalyticsDispatcher';
import { withIdentities as higherOrder } from '../../extenders';
function withIdentities(identities) {
    return higherOrder(identities)(this);
}
AnalyticsDispatcher.prototype.withIdentities = withIdentities;
//# sourceMappingURL=withIdentities.js.map